import React, { PropTypes } from 'react';
import { Profession } from 'components';
import Translate from 'react-translate-component';
import SaveVacationOptions from './save-vacation-options';

export class InvoicingInformation extends React.Component {

  static propTypes = {
    userData: PropTypes.object.isRequired,
    showErrorWithoutBlur: PropTypes.bool.isRequired,
    callback: PropTypes.func.isRequired
  };

  render () {
    return (<div className='modal-information-container'>
      <div className='input-row-container'>
        <Translate
          className='invoicing-description'
          content='COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_DESCRIPTION'
        />
      </div>
      <div className='input-row-container'>
        <Profession
          value={this.props.userData.profession.value}
          name='profession'
          showErrorWithoutBlur={this.props.showErrorWithoutBlur}
          callback={this.props.callback} />
      </div>
      <div className='input-row-container invoicing-sub-description'>
        <Translate
          className='invoicing-sub-description'
          content='COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SUB_DESCRIPTION'
        />
      </div>
      <div className='input-row-container top-divider mobile-column'>
        <SaveVacationOptions
          callback={this.props.callback}
          userData={this.props.userData}
        />
        <div className='input-row-column justify-center'>
          <Translate
            className='invoicing-sub-description box-container'
            content='COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION_INFO'
          />
        </div>
      </div>
    </div>);
  }
}

export default InvoicingInformation;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/invoicing-information.js
 **/